import React from 'react';
import '../assets/styles/selectDate.css'; 

const SelectDate = ({ selectedYear, onChange,componentTitle }) => {
   const startYear = 2022;  
  const endYear = new Date().getFullYear();  
  const years = [];

  for (let year = endYear; year >= startYear; year--) {
    years.push(year);
  }

  return (
    <div className="select-date-container">
      <label htmlFor="year-select" className="select-date-label">{componentTitle}</label>
       <select
        id="year-select"
        className="select-date-dropdown"
        value={selectedYear}
        onChange={(e) => onChange(parseInt(e.target.value, 10))} 
      >
         {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectDate;